/*
 * @Author       : gentlelts@163.com
 * @Date         : 2020-09-16 17:34:02
 * @LastEditors  : lts
 * @LastEditTime : 2020-10-13 20:56:07
 * @FilePath     : \belle\src\app\main\loginSingle\loginSingleCtrl.js
 */
class loginSingleCtrl {
  /**
   * 模块只负责用户单点登陆
   * 登陆后只会被重定向到 /home/admin  或/user
   * 之前或之后的控制逻辑通常由 mainCtrl 负责
   *
   */
  constructor(
    $scope,
    httpRequest,
    sweetalert,
    $rootScope,
    $http,
    $timeout,
    $uibModalStack,
    $location,
    $state,
    $cacheFactory
  ) {
    $scope.logging = false;
    window.layer.closeAll();
    $uibModalStack.dismissAll();
    $scope.autoHeightConfig = {
      headerHeight: 0,
      footerHeight: 60,
    };

    // 获取用户权限列表
    function getFunctionListByUser(token) {
      $.ajax({
        // url: '../../auth/sysFunction/getFunctionListByUser',
        url: `${host.etcloud}auth/sysFunction/getFunctionListByUser`,
        async: false,
        type: 'GET',
        beforeSend(XMLHttpRequest) {
          XMLHttpRequest.setRequestHeader('accessToken', token);
        },
        contentType: 'application/json; charset=utf-8',
        success(data) {
          if (data.success) {
            window.localStorage.setItem(
              'function_list',
              JSON.stringify(data.value)
            );
            $rootScope.$broadcast('logIn', true);
            $scope.$emit('logoChange');
          } else {
            $scope.loginError = '系统忙，请稍后再试';
          }
        },
      });
    }

    // 用户信息信息获取
    function setUserInfo(token) {
      $.ajax({
        url: `${host.etcloud}auth/login/getLoginInfo`,
        async: false,
        type: 'GET',
        beforeSend(XMLHttpRequest) {
          XMLHttpRequest.setRequestHeader('accessToken', token);
        },
        contentType: 'application/json; charset=utf-8',
        success(data) {
          if (data.success) {
            const userInfo = data.value;
            const roleIdList = userInfo.user.roleIdList;
            const roleList = userInfo.user.roleList;
            $rootScope.userRoleIdList = roleIdList
            $rootScope.userRoleList = roleList
            userInfo.user.roleIdList = [];
            userInfo.user.roleList = [];
            window.localStorage.setItem('user_info', JSON.stringify(userInfo));
            // 获取权限
            getFunctionListByUser(token);
            // window.location.href = goUrl
          } else {
            // mini.hideMessageBox(loadingId)
            // mini.alert(data.message)
            $scope.loginError = data.message;
          }
        },
      });
    }
    $scope.accessToken = $location.search().accessToken;
    // 提交用户登陆,换取真正的token
    $scope.submitLoginSingle = function submitLoginSingle() {
      localStorage.setItem('id_token', $scope.accessToken);
      // 获取用户信息
      setUserInfo($scope.accessToken);
    };
    // 没有accessToken禁止跳转 展示错误页面
    if ($scope.accessToken == '') {
      console.log($scope.accessToken);
      return;
    }
    $scope.submitLoginSingle();

    // 不注释 则单点登陆无下拉框
    // $('html').addClass('et-overflow-hidden')
    // $scope.$on('$stateChangeStart', () => {
    //   $('html').removeClass('et-overflow-hidden')
    // })
  }
}
loginSingleCtrl.$inject = [
  '$scope',
  'httpRequest',
  'sweetalert',
  '$rootScope',
  '$http',
  '$timeout',
  '$uibModalStack',
  '$location',
  '$state',
  '$cacheFactory'
];
export default loginSingleCtrl;



// WEBPACK FOOTER //
// ./src/app/main/loginSingle/loginSingleCtrl.js